export default "__VITE_ASSET__cef962c9__"